export enum PipelineContents {
    Crude_Oil = 'Crude_Oil',
    Natural_Gas = 'Natural_Gas',
    Produced_Water = 'Produced_Water',
    Fresh_Water = 'Fresh_Water',
    NGL = 'NGL',
    CO2 = 'CO2',
    Steam = 'Steam',
    Mixed = 'Mixed',
    Unknown = 'Unknown',
}
